import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { number, string, object } from 'prop-types';
import CollectionList from './CollectionList';
import { getBaseApiUrl, API_VERSION } from '../../config';

class PromoGroupItems extends PureComponent {
  static propTypes = {
    offerId: number.isRequired,
    banner: object.isRequired,
    collectionId: number.isRequired,
    staticPath: string.isRequired,
  };
  static defaultProps = {
    banner: {},
  };

  state = {
    open: false,
  };

  getDownloadLink = (offerId, collectionId, size) => {
    const baseUrl = getBaseApiUrl();
    return `${baseUrl}/${API_VERSION}/offers/${offerId}/collection/${collectionId}/?size=${size}`;
  }

  toggle = e => {
    e.preventDefault();
    this.setState(prevState => ({ open: !prevState.open }));
  };

  render() {
    const { banner, offerId, staticPath, collectionId } = this.props;
    const { open } = this.state;

    return (
      <tbody className="group-section">
        <tr className="group-item">
          <td>
            <a role="button" className="group-controller" onClick={this.toggle}>
              {banner.size}
            </a>
          </td>
          <td className="text-right">
            <a
              href={this.getDownloadLink(offerId, collectionId, banner.size)}
              className="btn btn-primary btn-sm"
              target="_blank"
              download
            >
              <FormattedMessage id="main.download" defaultMessage="Download" />
            </a>
          </td>
        </tr>
        {open && (
          <tr>
            <td colSpan="2">
              <CollectionList staticPath={staticPath} offerId={offerId} collection={banner.imgs} />
            </td>
          </tr>
        )}
      </tbody>
    );
  }
}

export default PromoGroupItems;
